"use client";

import React, { ReactNode } from "react";

import ErrorComponent from "../../ErrorComponent";

import { useAppSelector } from "../../../utils/hooks/store";
import * as styledElements from "./SearchStyles";
import PartsTableAndFilters from "../PartsTableAndFilters";
import CategorySidebar from "../CategorySidebar";
import LoadingOverlay from "../../LoadingOverlay";
import { Category } from "../../../reducers/models/categories";

interface SearchPageProps {
  categories: Category[] | null;
  selectedPartId?: string | null;
  setSelectedPartId: (part_id: string | null) => void;
  warnOnNoInventory?: boolean;
  noPartsComponent?: ReactNode;
}

export default function Search({
  categories,
  selectedPartId,
  setSelectedPartId,
  warnOnNoInventory,
  noPartsComponent,
}: SearchPageProps) {
  const searchResponse = useAppSelector(
    (state) => state.componentSearch.searchResponse,
  );
  const searchParameters = useAppSelector(
    (state) => state.componentSearch.searchParameters,
  );
  const errored = useAppSelector((state) => state.componentSearch.errored);
  const loading = useAppSelector((state) => state.componentSearch.loading);
  const notFullyHydrated =
    categories === null || searchResponse === null || searchParameters === null;

  function renderResults() {
    if (notFullyHydrated) {
      return null;
    }
    return (
      <styledElements.ResultsContainer>
        <CategorySidebar
          categories={categories}
          selectedCategoryIds={searchParameters.categoryIds}
        />
        <PartsTableAndFilters
          searchResponse={searchResponse}
          selectedPartId={selectedPartId}
          setSelectedPartId={setSelectedPartId}
          warnOnNoInventory={warnOnNoInventory || false}
          noPartsComponent={noPartsComponent}
        />
      </styledElements.ResultsContainer>
    );
  }

  if (errored) {
    return <ErrorComponent />;
  }

  return (
    <>
      <styledElements.Container>{renderResults()}</styledElements.Container>{" "}
      <LoadingOverlay
        loading={notFullyHydrated || loading}
        text={"Searching"}
      />
    </>
  );
}
